import PropTypes from "prop-types"
import React, { useCallback, useEffect, useState } from "react"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import withRouter from "../Common/withRouter"
import { Link, useLocation } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import SkeletonLoading from "./SkeletonLoader"
import DashboardIcon from "../../assets/icons/iconComponents/dashboardIcon"
import ProductMasterIcon from "../../assets/icons/iconComponents/productMasterIcon"
import EstimateIcon from "../../assets/icons/iconComponents/estimateIcon"
import ProjectManagementIcon from "../../assets/icons/iconComponents/projectManagementIcon"
import LogoutIcon from "../../assets/icons/iconComponents/logOutIcon"
import ProcurementIcon from "../../assets/icons/iconComponents/procurementIcon"
import HrmsIcon from "../../assets/icons/iconComponents/hrmsIcon"
import SettingsIcon from "../../assets/icons/iconComponents/settingsIcon"
import FinanceIcon from "../../assets/icons/iconComponents/financeIcon"
import MenuBackIcon from "../../assets/icons/iconComponents/sidebarback"
import MenuDropIcon from "../../assets/icons/iconComponents/menudroparrow"
import CentralStoreIcon from "../../assets/icons/iconComponents/centralStoreIcon"
import LogoutPopup from "./logoutpopup"
import useAppVersion from "../../utils/useAppVersion"

const SidebarContent = props => {
  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const location = useLocation()
  const { loggedUser } = useSelector(LoginProperties)

  const version = useAppVersion()

  // FIXED: Keep localStorage for global settings, use sessionStorage for menu state
  localStorage.setItem(
    "desimalrange",
    Number(loggedUser?.settings?.desimal_point)
  )

  localStorage.setItem(
    "companyname",
    loggedUser?.settings?.companyname == undefined
      ? "MEP -Hub"
      : loggedUser?.settings?.companyname
  )

  const body = document.body.getAttribute("data-sidebar-size")

  const [menuItems, setMenuItems] = useState([])
  const [selectedMenu, setSelectedMenu] = useState(null)
  const [subMenuGroups, setSubMenuGroups] = useState([])
  const [activeSubmenu, setActiveSubmenu] = useState(null)
  const [activeGroup, setActiveGroup] = useState(null)
  const [logoutModal, setLogoutModal] = useState(false)
  const [menuHistory, setMenuHistory] = useState([])

  console.log("subMenuGroups", subMenuGroups)

  useEffect(() => {
    const initializeFromSessionStorage = () => {
      try {
        // FIXED: Use sessionStorage instead of localStorage for tab-specific state
        if (sessionStorage.getItem("selectedmenu") === "[object Object]") {
          sessionStorage.removeItem("selectedmenu")
        }
        if (sessionStorage.getItem("submenugroup") === "[object Object]") {
          sessionStorage.removeItem("submenugroup")
        }
        if (sessionStorage.getItem("menuhistory") === "[object Object]") {
          sessionStorage.removeItem("menuhistory")
        }

        const storedSelectedMenu = sessionStorage.getItem("selectedmenu")
        const storedSubMenuGroups = sessionStorage.getItem("submenugroup")
        const storedMenuHistory = sessionStorage.getItem("menuhistory")

        if (storedSelectedMenu) {
          try {
            const parsedMenu = JSON.parse(storedSelectedMenu)
            if (parsedMenu && typeof parsedMenu === "object") {
              setSelectedMenu(parsedMenu)
              // FIXED: Use sessionStorage for active group too
              const menuSpecificActiveGroup = sessionStorage.getItem(
                `activegroup_${parsedMenu.id}`
              )
              if (menuSpecificActiveGroup) {
                setActiveGroup(menuSpecificActiveGroup)
              }
            } else {
              sessionStorage.removeItem("selectedmenu")
            }
          } catch (e) {
            console.error("Error parsing selectedmenu:", e)
            sessionStorage.removeItem("selectedmenu")
          }
        }

        if (storedSubMenuGroups) {
          try {
            const parsedGroups = JSON.parse(storedSubMenuGroups)
            if (Array.isArray(parsedGroups)) {
              setSubMenuGroups(parsedGroups)
            } else {
              sessionStorage.removeItem("submenugroup")
            }
          } catch (e) {
            console.error("Error parsing submenugroup:", e)
            sessionStorage.removeItem("submenugroup")
          }
        }

        if (storedMenuHistory) {
          try {
            const parsedHistory = JSON.parse(storedMenuHistory)
            if (Array.isArray(parsedHistory)) {
              setMenuHistory(parsedHistory)
            } else {
              sessionStorage.removeItem("menuhistory")
            }
          } catch (e) {
            console.error("Error parsing menuhistory:", e)
            sessionStorage.removeItem("menuhistory")
          }
        }
      } catch (error) {
        console.error("Error initializing sidebar state:", error)
      }
    }

    initializeFromSessionStorage()
  }, [])

  const getSubMenus = mainMenuId => {
    if (!loggedUser?.permission) return []

    console.log(`subMenus mainMenuId`, mainMenuId, loggedUser.permission)

    const subMenus = loggedUser.permission.filter(
      item => item.is_submodule === mainMenuId && item.is_menu === 1
    )

    console.log(`subMenus subMenus --`, subMenus)

    const groups = {}
    subMenus.forEach(item => {
      const tagline = item.tagline || "Others"
      if (!groups[tagline]) {
        groups[tagline] = []
      }
      groups[tagline].push(item)
    })

    return Object.entries(groups).map(([tagline, items]) => ({
      tagline,
      items,
    }))
  }

  useEffect(() => {
    if (loggedUser) {
      const permittedMenus = loggedUser?.smenu?.filter(dt =>
        loggedUser?.permission?.some(
          permissionItem => permissionItem?.id === dt.id
        )
      )

      setMenuItems(permittedMenus)
    }
  }, [loggedUser])

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show")

        const parent3 = parent2.parentElement

        if (parent3) {
          parent3.classList.add("mm-active")
          parent3.childNodes[0].classList.add("mm-active")
          const parent4 = parent3.parentElement
          if (parent4) {
            parent4.classList.add("mm-show")
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show")
              parent5.childNodes[0].classList.add("mm-active")
            }
          }
        }
      }
      return false
    }
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active")
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement
            if (parent4) {
              parent4.classList.remove("mm-show")
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show")
                parent5.childNodes[0].classList.remove("mm-active")
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName.includes(items[i].pathname)) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    const menu = new MetisMenu("#side-menu")
    activeMenu()
    return () => {
      menu.dispose()
    }
  }, [menuItems, activeMenu])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [path.pathname])

  const iconMap = {
    dashImg: DashboardIcon,
    projectImg: ProjectManagementIcon,
    estimateImg: EstimateIcon,
    productMasterImg: ProductMasterIcon,
    procureImg: ProcurementIcon,
    hrmsImg: HrmsIcon,
    settingsImg: SettingsIcon,
    financeImg: FinanceIcon,
    centralStoreImg: CentralStoreIcon,
  }

  const getSubmenuIcon = taglines => {
    console.log(`taglines`, taglines)
    return iconMap[taglines] || EstimateIcon
  }

  const goBackInMenu = () => {
    if (menuHistory.length === 0) {
      closeTopBar()
      return
    }

    const previousMenu = menuHistory[menuHistory.length - 1]

    const newHistory = menuHistory.slice(0, -1)
    setMenuHistory(newHistory)
    // FIXED: Use sessionStorage instead of localStorage
    sessionStorage.setItem("menuhistory", JSON.stringify(newHistory))

    setActiveSubmenu(null)

    if (previousMenu.level === "main") {
      setSelectedMenu(null)
      setSubMenuGroups([])
      sessionStorage.removeItem("selectedmenu")
      sessionStorage.removeItem("submenugroup")
    } else if (previousMenu.level === "submenu") {
      setSelectedMenu(previousMenu.menu)
      setSubMenuGroups(previousMenu.groups)
      // FIXED: Use sessionStorage instead of localStorage
      sessionStorage.setItem("selectedmenu", JSON.stringify(previousMenu.menu))
      sessionStorage.setItem(
        "submenugroup",
        JSON.stringify(previousMenu.groups)
      )
    }
  }

  const handleMenuClick = (dt, e) => {
    try {
      const selected =
        Array.isArray(dt?.submenus) && dt.submenus.length
          ? dt
          : loggedUser?.smenu?.find(item => item.id === dt?.id)

      // console.log(`selected subMenus`, selected);

      if (selected) {
        const permittedSubmenus = (selected.submenus || []).filter(sub =>
          loggedUser?.permission?.some(perm => perm?.is_submodule == sub.id)
        )

        // console.log("permittedSubmenus", permittedSubmenus?.length <= 1, permittedSubmenus, selected);
        if (selectedMenu) {
          const newHistory = [
            ...menuHistory,
            {
              menu: selectedMenu,
              groups: subMenuGroups,
              level: selectedMenu.id ? "submenu" : "main",
            },
          ]
          setMenuHistory(newHistory)
          // FIXED: Use sessionStorage instead of localStorage
          sessionStorage.setItem("menuhistory", JSON.stringify(newHistory))
        }

        setSelectedMenu(selected)
        setSubMenuGroups(
          permittedSubmenus?.length <= 1 ? selected.submenus : permittedSubmenus
        )

        // FIXED: Use sessionStorage instead of localStorage
        sessionStorage.setItem("selectedmenu", JSON.stringify(selected))
        sessionStorage.setItem(
          "submenugroup",
          JSON.stringify(
            permittedSubmenus?.length <= 1
              ? selected.submenus
              : permittedSubmenus
          )
        )
      } else {
        console.warn("Menu item not found in smenu for id:", dt?.id)
      }
    } catch (error) {
      console.error("Error handling menu click:", error)
    }
  }

  const closeTopBar = () => {
    try {
      // FIXED: Use sessionStorage instead of localStorage
      sessionStorage.removeItem("selectedmenu")
      sessionStorage.removeItem("submenugroup")
      sessionStorage.removeItem("menuhistory")
      if (selectedMenu?.id) {
        sessionStorage.removeItem(`activegroup_${selectedMenu.id}`)
      }
    } catch (error) {
      console.error("Error clearing sidebar state:", error)
    }
    setSelectedMenu(null)
    setActiveGroup(null)
    setActiveSubmenu(null)
    setMenuHistory([])
  }

  useEffect(() => {
    if (selectedMenu?.linkTo === "/dashboard") {
      closeTopBar()
    }
    if (location.pathname === "/dashboard") {
      closeTopBar()
    }
  }, [location.pathname, selectedMenu])

  useEffect(() => {
    if (activeSubmenu !== location.pathname) {
      setActiveSubmenu(null)
    }
  }, [activeSubmenu, location.pathname])

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "95%" }}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("MODULES")}</li>

            {!loggedUser?.smenu?.length ? (
              <SkeletonLoading />
            ) : (
              <>
                {menuItems
                  ?.filter(dt =>
                    loggedUser?.permission?.some(
                      permissionItem => permissionItem?.id === dt.id
                    )
                  )
                  .map((dts, i) => {
                    const IconComponent = iconMap[dts?.icon] || EstimateIcon
                    const isActive =
                      location.pathname === dts?.linkTo ||
                      location.pathname.startsWith(`${dts?.linkTo}/`) ||
                      selectedMenu?.id === dts.id

                    return (
                      <li key={`side_${i}`} className="list-ofsvg-color">
                        <Link
                          to={dts?.linkTo}
                          className="waves-effect d-flex"
                          onClick={e => handleMenuClick(dts, e)}
                        >
                          <IconComponent
                            className="me-3 side-menu-icon"
                            active={isActive ? isActive : ""}
                          />
                          <div className="d-flex align-items-center sidebar-menus-li">
                            {props.t(`${dts?.label}`)}
                          </div>
                        </Link>
                      </li>
                    )
                  })}
                {loggedUser?.smenu && (
                  <li className="logout-color">
                    <Link
                      to="#"
                      className="waves-effect d-flex"
                      onClick={e => {
                        e.preventDefault()
                        setLogoutModal(true)
                      }}
                    >
                      <LogoutIcon className={`me-3 side-menu-icon`} />
                      <div className="d-flex align-items-center">Logout</div>
                    </Link>
                  </li>
                )}
              </>
            )}
          </ul>
          {selectedMenu && subMenuGroups.length > 0 && (
            <div
              className={`${body === "sm" ? "submenu-top-bar-small" : "submenu-top-bar"
                }`}
            >
              <div className="submenu-container">
                <button className="close-submenu">×</button>
              </div>
              <SimpleBar style={{ maxHeight: "90%" }}>
                <ul className="metismenu list-unstyled mt-19-ul-sub">
                  <li
                    className="menu-title menu-title-submenu"
                    onClick={() => goBackInMenu()}
                  >
                    <span>←</span>&nbsp;&nbsp;{selectedMenu?.label}
                  </li>
                  {subMenuGroups?.map((group, groupIndex) => {
                    const IconComponent = getSubmenuIcon(group?.icon)

                    console.log(`menuGroup`, group)

                    return (
                      <li
                        key={`group_${groupIndex}`}
                        className="list-ofsvg-color"
                      >
                        {body === "sm" ? (
                          <div className={body === "sm" ? "dropdown" : ""}>
                            <Link
                              to={`${group?.linkTo}`}
                              className={`waves-effect pe-0 d-flex dropdown-toggle my-0 ${body === "sm"
                                  ? "hovering-sub-title dropbtn custome-new-padding"
                                  : ""
                                }  ${activeSubmenu === group.linkTo ||
                                  location.pathname === `/${group.linkTo}` ||
                                  location.pathname.startsWith(
                                    `/${group.linkTo}/`
                                  ) ||
                                  location.pathname.includes(`/${group.linkTo}-`)
                                  ? "active-submenu-list mm-active"
                                  : ""
                                }`}
                              onClick={e => {
                                handleMenuClick(group, e)
                                setActiveSubmenu(group.linkTo)
                              }}
                            >
                              {body === "lg" && (
                                <IconComponent className="me-3 side-menu-icon" />
                              )}
                              {body === "sm" && (
                                <IconComponent className="side-menu-icon" />
                              )}
                              {body === "sm" && (
                                <div
                                  className={`d-flex align-items-center sidebar-menus-li hiding-sub-title ${body === "sm" ? "tagline-title-sm" : ""
                                    }`}
                                >
                                  {group.label == "Your Shortcuts"
                                    ? "Masters"
                                    : group.label}
                                </div>
                              )}
                              {body === "lg" && (
                                <div className="d-flex align-items-center sidebar-menus-li">
                                  {group.label}
                                </div>
                              )}
                            </Link>
                          </div>
                        ) : (
                          <>
                            <Link
                              to={`${group?.linkTo}`}
                              state={{ menuLabel: selectedMenu?.label }}
                              className={`margin-of-submenu-title waves-effect d-flex justify-content-between dropdown-toggle my-0 ${activeSubmenu === group.linkTo ||
                                  location.pathname === `/${group.linkTo}` ||
                                  location.pathname.startsWith(
                                    `/${group.linkTo}/`
                                  ) ||
                                  location.pathname.includes(`/${group.linkTo}-`)
                                  ? "active-submenu-list mm-active"
                                  : ""
                                }`}
                              onClick={e => {
                                handleMenuClick(group, e)
                                setActiveSubmenu(group.linkTo)
                              }}
                            >
                              <div className="d-flex">
                                <IconComponent className="me-3 side-menu-icon" />
                                <div className="d-flex align-items-center sidebar-menus-li">
                                  {group.label}
                                </div>
                              </div>
                            </Link>
                          </>
                        )}
                      </li>
                    )
                  })}
                </ul>
                {body === "sm" && (
                  <div
                    className="ms-3 mt-2 style-of-goback"
                    onClick={() => goBackInMenu()}
                  >
                    <div className="padding-of-back">
                      <MenuBackIcon />
                      <span>Go Back</span>
                    </div>
                  </div>
                )}
              </SimpleBar>
              {body !== "sm" && (
                <div className="note-txt text-center">
                  {version ? `Version #${version}` : ""}
                </div>
              )}
            </div>
          )}
        </div>
        {body !== "sm" && (
          <div className="note-txt text-center">
            {version ? `Version #${version}` : ""}
          </div>
        )}
      </SimpleBar>
      <LogoutPopup
        isOpen={logoutModal}
        toggle={() => setLogoutModal(!logoutModal)}
        router={props.router}
        logout={true}
      />
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  router: PropTypes.object.isRequired,
}

export default withRouter(withTranslation()(SidebarContent))
